import { Card, Modal } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import {
	clearLeaveApplication,
	loadOverlappingLeaves,
	loadSingelLeaveApplication,
} from "../../redux/rtk/features/leave/leaveSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ReviewLeavePopup from "../UI/PopUp/ReviewLeavePopup";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

const DetailLeave = () => {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [contradictionDetails, setContradictionDetails] = useState([]);

	const { id } = useParams("id");
	const leave = useSelector((state) => state.leave.leave);
	const overlap = useSelector((state) => state.leave.overlappingLeaves)
	console.log("ov", overlap);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadSingelLeaveApplication(id));

		return () => {
			dispatch(clearLeaveApplication());
		};
	}, []);

	useEffect(() => {
		if (leave?.leaveFrom && leave?.leaveTo) {
			dispatch(loadOverlappingLeaves({ leaveFrom: leave?.leaveFrom, leaveTo: leave?.leaveTo }))
		}
	}, [leave]);

	// const contradictions = overlap.filter((o) => o.leaveId !== leave?.id);
	const contradictions = (overlap || []).filter((o) => o.leaveId !== leave?.id);


	const handleViewContradictions = () => {
		setContradictionDetails(contradictions); // Set contradiction details in state
		setIsModalVisible(true); // Show the pop-up
	};

	const handleCloseModal = () => {
		setIsModalVisible(false); // Close the pop-up
	};

	return (
		<div>
			<PageTitle title='Back' />
			<UserPrivateComponent permission={"readSingle-leaveApplication"}>
				<Card className='mt-4'>
					<div className='text-center mb-4'>
						{" "}
						<h2 className='text-2xl font-semibold text-gray-600'>
							Leave Application {" "}
						</h2>
					</div>
					{leave ? (
						<div className='flex justify-center '>
							<ul className='list-inside list-none border-2 border-inherit rounded px-5 py-5 '>
								<ListItem>
									Name :{" "}
									{/* <TextInside>
										{(
											leave?.user.firstName +
											" " +
											leave?.user.lastName
										).toUpperCase()}{" "}
									</TextInside> */}
									<TextInside>
										{(leave?.user?.firstName && leave?.user?.lastName)
											? (leave.user.firstName + " " + leave.user.lastName).toUpperCase()
											: "User information not available"}
									</TextInside>

								</ListItem>
								<ListItem>
									Leave Type :{" "}
									<TextInside>
										{leave.leavePolicy?.name || "Unknown"}
									</TextInside>
								</ListItem>

								{/* <TextInside>
									{typeof leave.leaveType === "object"
										? leave.leaveType.name || JSON.stringify(leave.leaveType)
										: leave.leaveType || "Unknown"}
								</TextInside> */}
								<ListItem>
									Leave From :{" "}
									<TextInside>
										{dayjs(leave.leaveFrom).format("DD-MM-YYYY")}
									</TextInside>
								</ListItem>

								<ListItem>
									Leave To :{" "}
									<TextInside>
										{dayjs(leave.leaveTo).format("DD-MM-YYYY")}
									</TextInside>
								</ListItem>

								<ListItem>
									Leave Duration :{" "}
									<TextInside className='text-red-500'>
										{leave.totalleaveDays}
									</TextInside>
								</ListItem>

								<ListItem>
									Leave Reason :{" "}
									<TextInside>{leave.reason || "No reason"}</TextInside>
								</ListItem>

								<ListItem>
									Leave Status :{" "}
									<TextInside>
										{leave?.status === "pending" ? (
											<span className='text-yellow-500'>
												{leave?.status?.toUpperCase()}
											</span>
										) : leave?.status === "accepted" ? (
											<span className='text-green-500'>
												{leave?.status?.toUpperCase()}
											</span>
										) : (
											<span className='text-red-500'>
												{leave?.status?.toUpperCase()}
											</span>
										)}
									</TextInside>
								</ListItem>

								<ListItem>
									Leave Accepted From :{" "}
									<TextInside>
										{leave.acceptLeaveFrom
											? dayjs(leave.acceptLeaveFrom).format("DD-MM-YYYY")
											: "ON REVIEW"}
									</TextInside>
								</ListItem>

								<ListItem>
									Leave Accepted To :{" "}
									<TextInside>
										{leave.acceptLeaveTo
											? dayjs(leave.acceptLeaveTo).format("DD-MM-YYYY")
											: "ON REVIEW"}
									</TextInside>
								</ListItem>

								<ListItem>
									Leave Accepted By :{" "}
									<TextInside className='text-green-500'>
										{(leave.acceptLeaveBy?.firstName || "ON") +
											" " +
											(leave.acceptLeaveBy?.lastName || "REVIEW")}
									</TextInside>
								</ListItem>

								<ListItem>
									Review Comment :{" "}
									<TextInside>{leave.reviewComment || "No comment"}</TextInside>
								</ListItem>

								{/* <ListItem>
									Attachment :{" "}
									<TextInside>
										{leave.attachment ? (
											<a
												href={leave.attachment}
												target='_blank'
												rel='noreferrer'
												className='text-blue-500'>
												Download
											</a>
										) : (
											"No Attachment"
										)}
									</TextInside>
								</ListItem> */}

								<ListItem>
									Any Contradiction :{" "}
									<TextInside>
										{contradictions.length > 0 ? (
											<span
												className="text-blue-500 cursor-pointer"
												onClick={handleViewContradictions}
											>
												{contradictions.length} Contradiction(s)
											</span>
										) : (
											"None"
										)}
									</TextInside>
								</ListItem>
							</ul>
						</div>
					) : (
						<Loader />
					)}
					<UserPrivateComponent permission={"update-leaveApplication"}>
						{leave?.status === "PENDING" && (
							<div className='flex justify-center items-center'>
								<ReviewLeavePopup />
							</div>
						)}
						{leave?.status === "REJECTED" && (
							<div className='flex justify-center items-center'>
								<ReviewLeavePopup />
							</div>
						)}
					</UserPrivateComponent>
				</Card>
			</UserPrivateComponent>

			{/* Modal for Contradiction Details */}
			<Modal
				title="Contradiction Details"
				visible={isModalVisible}
				onCancel={handleCloseModal}
				footer={null}
			>
				{contradictionDetails.length > 0 ? (
					<ul>
						{contradictionDetails.map((contradiction, index) => (
							<li key={index} className="mb-2">
								<p>
									<strong>User:</strong> {contradiction.userName}
								</p>
								<p>
									<strong>Leave From:</strong>{" "}
									{dayjs(contradiction.leaveFrom).format("DD-MM-YYYY")}
								</p>
								<p>
									<strong>Leave To:</strong>{" "}
									{dayjs(contradiction.leaveTo).format("DD-MM-YYYY")}
								</p>
							</li>
						))}
					</ul>
				) : (
					<p>No contradictions found.</p>
				)}
			</Modal>

		</div>
	);

	// "reviewComment": null,
	// "attachment": null,
};

const ListItem = tw.li`
text-sm
text-gray-600
font-semibold
py-2
px-4
bg-gray-100
mb-1.5
rounded
w-96
flex
justify-start
`;

const TextInside = tw.p`
ml-2
text-sm
text-gray-900
`;
export default DetailLeave;
